export default {
    PTT: 'ac2a49a9-d7a4-4a5a-8884-c957e1fe23cc',
    NationalPathwayTourTagId: 'f33fc7ff-1dea-4b8d-b93e-ba1105256cb3',
};
